import { useEffect, useState } from "react";
import { api } from "../api/apiClient";
import type { CatalogItem } from "../api/types";

interface ItemPickerProps {
  value: string;
  onChange: (next: string) => void;
  required?: boolean;
  label?: string;
  /** When set, only items matching this predicate appear */
  filter?: (item: CatalogItem) => boolean;
}

export function ItemPicker({
  value,
  onChange,
  required = false,
  label = "Item",
  filter,
}: ItemPickerProps) {
  const [items, setItems] = useState<CatalogItem[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api
      .listItems()
      .then((rows) => {
        if (!cancelled) setItems(filter ? rows.filter(filter) : rows);
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : "Could not load items");
        }
      });
    return () => {
      cancelled = true;
    };
  }, [filter]);

  return (
    <div className="field">
      <label htmlFor="itemSelect">{label}{required ? " *" : ""}</label>
      <select
        id="itemSelect"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Select an item</option>
        {items.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name} ({item.category.label}, {item.defaultUom})
          </option>
        ))}
      </select>
      {error ? <div className="alert error">{error}</div> : null}
    </div>
  );
}
